module.exports = __webpack_public_path__ + "img/final.3c1b8e35.png";